<template>
<div class="keywods-wrapper">
    <div style="padding:10px 0;">
        <Button size="large" icon="md-add" type="primary" @click="add()">添加关键词</Button>
        <Input v-model="FormData.keyword" placeholder="请输入关键词" clearable style="width: 310px; margin-left:100px" />
        <Button type="primary" @click="searchKeyword()" icon="ios-search" style="margin-left: 10px">查询</Button>
    </div>

    <Table border :columns="columns12" :data="listData">
        <!-- <template slot-scope="{ row }" slot="num">
            <strong>{{ row.index }}</strong>
        </template> -->
        <template slot-scope="{ row, index }" slot="action">
            <Button type="primary" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
            <Button type="error" size="small" @click="remove(row)">删除</Button>
        </template>
    </Table>
    <div style="margin-top:20px;">
        <Page class-name="page-style fr" :total="pageTotal" @on-change="changepagesize" @on-page-size-change="changepage" :current.sync="FormData.page" show-total></Page>
    </div>
    <!-- 加载 -->
    <Spin size="large" fix v-if="spinShow"></Spin>
</div>
</template>

<script>
export default {
    data() {
        return {
            token: '',
            spinShow: false,
            FormData: {
                keyword: '',
                pageSize: 10,
                noPaginate: 1,
                page: 1
            },
            columns12: [{
                    title: '序号',
                    type: "index",
                    slot: 'num',
                    align: 'center'
                },
                {
                    title: '关键词',
                    key: 'keyword',
                    align: 'center'
                },
                {
                    title: '回复内容',
                    key: 'return',
                    align: 'center',
                    render: (h, params) => {
                        return params.row.type == 'text' ? h("span", {}, "文字") : params.row.type == 'graphic' ? h("span", {}, "图文") : params.row.type == 'image' ? h("span", {}, "图片") : h("span", {}, "外链接");
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 250,
                    align: 'center'
                }
            ],
            listData: [],
            pageTotal: 0,
        }
    },
    methods: {
        //搜索
        searchKeyword() {
            this.getKeyWordsList(this.FormData.keyword)
        },
        add() {
            this.$router.push({
                path: '/keywordsAdd',
            })
        },
        //编辑
        edit(row) {
            console.log(row.id)
            let id = row.id
            this.$router.push({
                path: '/KeywordsEdit',
                query: {
                    id: id
                }
            })
        },
        //删除
        remove(row) {
            this.spinShow = true
            this.$Modal.confirm({
                title: '请确认',
                content: '确定删除该关键词吗？',
                onOk: () => {
                    this.spinShow = true
                    this.$axios.post('/weixin/admin/deleteKeyword', {
                        id: row.id
                    }, {
                        headers: {
                            Authorization: this.token
                        }
                    }).then(res => {
                        this.spinShow = false
                        if (res.data.code === 0) {
                            this.$Message.success('已删除')
                            this.getKeyWordsList()
                        } else {
                            this.$Message.error('删除失败')
                        }
                    })
                },
                onCancel: () => {
                    this.spinShow = false
                }
            });

        },
        //获取关键词列表
        getKeyWordsList(keyword) {
            this.spinShow = true
            this.$axios.post('/weixin/admin/getKeywordList', {
                keyword: keyword,
                pageSize: this.FormData.pageSize,
                noPaginate: this.FormData.noPaginate,
                page: this.FormData.page
            }, {
                headers: {
                    Authorization: this.token
                }
            }).then(res => {
                this.spinShow = false
                if (res.data.code === 0) {
                    console.log(res)
                    this.loading = false;
                    // console.log(res.data);
                    this.listData = res.data.data.list;
                    this.pageTotal = res.data.data.allCount;
                } else {
                    // this.$Message.error('请重新上传图片')
                }
            })
        },
        changepagesize(e) {
            this.FormData.page = e;
            // console.log(e);
            this.getKeyWordsList();
        },
        changepage(e) {
            this.FormData.pageSize = e;
            // console.log(e);
            this.getKeyWordsList();
        },
    },
    created() {
        this.token = localStorage.getItem('token')
        this.getKeyWordsList()
    },
}
</script>

<style>

</style>
